import { Button, Label } from "@inkblot-therapy/squid"
import { Icon } from "../Icon"
import classNames from "classnames"
import { useTranslation } from "react-i18next"

type UploadedStateProps = {
  error?: string
  validationHasErrors: boolean
  file?: File
  onRemoveFile: () => void
  isReviewing: boolean
  setIsReviewing: (isReviewing: boolean) => void
  setFile: (file: File | undefined) => void
}

export const UploadedState = ({
  error,
  validationHasErrors,
  file,
  onRemoveFile,
  isReviewing,
  setIsReviewing,
  setFile,
}: UploadedStateProps) => {
  const { t } = useTranslation()

  return (
    <>
      {!error && !validationHasErrors && file && (
        <div
          className={classNames(
            "p-2 rounded-xl border mt-4 grid grid-cols-3 mb-5",
            {
              "rounded-br-none rounded-bl-none border-b-0 -mb-5": isReviewing,
            },
          )}
        >
          <div className="col-span-2 flex">
            <div className="p-2">
              <Icon
                className="rounded-full bg-blue-100 p-3 text-blue-500 text-lg"
                variant="DocumentText"
                size="md"
                wrapped={true}
              />
            </div>
            <Label className="items-center flex gap-3" strong={false}>
              {file.name}
            </Label>
          </div>
          <div className="col-span-1 flex flex-col items-end gap-1">
            <div className="flex gap-1">
              <Button
                variant="text"
                className="p-0 hover:bg-transparent focus:outline-none focus:ring-0 focus:ring-offset-0 active:outline-none active:ring-0 outline-none ring-0"
                onClick={() => {
                  onRemoveFile()
                  setFile(undefined)
                }}
              >
                {t("client.buttons.remove")}
              </Button>
              <span className="text-gray-300 p-2">|</span>
              <Button
                variant="text"
                className="p-0 m-0 hover:bg-transparent focus:outline-none focus:ring-0 focus:ring-offset-0 active:outline-none active:ring-0 outline-none ring-0"
                onClick={() => setIsReviewing(!isReviewing)}
              >
                {isReviewing
                  ? t("client.buttons.close")
                  : t("client.buttons.review")}
              </Button>
            </div>
            <Label
              strong={false}
              className="flex items-center gap-1 text-[color:var(--alias-color-text-success)] text-sm -mt-2"
            >
              <Icon wrapped={true} variant="CheckCircle" size="sm" />
              {t("client.fileupload.uploadComplete")}
            </Label>
          </div>
        </div>
      )}
    </>
  )
}
